import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Api } from '../../api'
import type { Collection } from '../../collection'
import type { Feature } from '../feature'

/** Streams persisted run progress for every connector loaded in the zone. */
export const subscribeRunProgress = store.effects.create(
  (feature: Feature, collection: Collection, api: Api) =>
    rxjs
      .combineLatest([
        collection.feature.selectors.context.asObservable,
        collection.plugins.currentListPlugin.feature.selectors.entities
          .asObservable,
      ])
      .pipe(
        rxjs.map(([context, connectors]) => ({
          connectors: connectors.map(({ id }) => id),
          context,
        })),
        rxjs.distinctUntilChanged(
          (previous, current) =>
            previous.context?.tenantId === current.context?.tenantId &&
            previous.context?.zoneId === current.context?.zoneId &&
            previous.connectors.length === current.connectors.length &&
            previous.connectors.every(
              (connectorId, index) =>
                connectorId === current.connectors[index],
            ),
        ),
        rxjs.switchMap(({ connectors, context }) =>
          context && connectors.length > 0
            ? rxjs.merge(
                ...connectors.map(connectorId =>
                  api
                    .subscribeRun(context, connectorId)
                    .pipe(rxjs.retry({ delay: 1000 })),
                ),
              )
            : rxjs.EMPTY,
        ),
        rxjs.map(({ connectorId, run }) =>
          feature.actions.progress
            .from('IntegrationRun.Subscription.Progress.Received')
            .create({ connectorId, run }),
        ),
      ),
)
